import { Euler as t, Quaternion as n } from "three";
import { getEuler as o } from "./index7.js";
const u = new t();
function f(e, r = new n()) {
  return r.setFromEuler(o(e, u));
}
export {
  f as getQuaternion
};
//# sourceMappingURL=index13.js.map
